import { useState, useCallback } from "react";
import { getSizeFieldsForCategory } from "../../../dashboard/merchant/utils/categoryFormConfig";
import { getProductSizes, getProductStockAvailable } from "./productSizes";
import { addProductToCart } from "./cartAddHelpers";

const useQuickAddToCart = (addItemToCart) => {
  const [pending, setPending] = useState(null);

  const quickAdd = useCallback(
    (product, quantity = 1) => {
      const sizeFields = getSizeFieldsForCategory(product.category);
      const sizes = getProductSizes(product, sizeFields);

      if (sizes.length === 0) {
        return addProductToCart(addItemToCart, product, quantity);
      }

      setPending({ product, sizes, sizeFields, quantity });
      return { success: false, needsSize: true };
    },
    [addItemToCart]
  );

  const confirmSize = useCallback(
    (selectedSize) => {
      if (!pending) return;
      const { product, sizeFields, quantity } = pending;
      const stockAvailable = getProductStockAvailable(product, selectedSize, sizeFields);
      addProductToCart(
        addItemToCart,
        { ...product, selectedSize, stockAvailable },
        quantity
      );
      setPending(null);
    },
    [addItemToCart, pending]
  );

  const cancelSize = useCallback(() => setPending(null), []);

  return { quickAdd, pending, confirmSize, cancelSize };
};

export default useQuickAddToCart;
